module.exports = __webpack_public_path__ + "img/cpany2.ed63f0b3.png";